import * as React from 'react';
import isEqual from 'react-fast-compare';

export function withMemo(FunctionalComponent: React.FunctionComponent<any>): React.FunctionComponent<any> {
    const memoizedComponent: React.FunctionComponent<any> = props => <FunctionalComponent {...props} />;
    memoizedComponent.displayName = 'withMemo';

    return React.memo(memoizedComponent, ((prevProps, nextProps) => isEqual(prevProps, nextProps)));
}
